import React, { Suspense } from 'react';
import { useLocation } from 'react-router';

import { PermissionedView } from '@cvt/components/Permissioned';
import { ListLoading } from '@cvt/components/layout/ListLoading';

import { useNextAssertion } from '@modules/Assertions/hooks/useNextAssertion';
import { NoAssertions } from '@pages/Assertions/NoAssertions';
import { Paper } from '@mui/material';
import { DisciplineRow, DisciplineRowSkeleton } from '../components/DisciplineRowWithOptions';
import { InfiniteDisciplinesList } from '../partials/InfiniteDisciplinesList';

interface ViewProps {}

export const Disciplines: React.FC<ViewProps> = () => {
  const location = useLocation();
  const { next } = useNextAssertion();

  const [dismissNoAssertions, setDismissNoAssertions] = React.useState(false);

  const shouldShowNoAssertions =
        !dismissNoAssertions && ((next?.totalAnswered ?? 0) === 0);

  return (
    <PermissionedView permission="disciplines.list">
      {shouldShowNoAssertions ? (
        <NoAssertions
          objectKey="disciplines"
          onSeeList={() => setDismissNoAssertions(true)}
        />
      ) : (
        <Paper
          variant="elevation"
          elevation={1}
          sx={{ overflow: 'hidden', width: '100%' }}
        >
          <Suspense
            key={location.key}
            fallback={
              <ListLoading
                disablePadding
                repeat={6}
                renderItem={() => <DisciplineRowSkeleton />}
              />
            }
          >
            <InfiniteDisciplinesList
              renderItem={(discipline) => (
                <DisciplineRow key={discipline.id} {...discipline} />
              )}
              renderSkeleton={() => <DisciplineRowSkeleton />}
            />
          </Suspense>
        </Paper>
      )}
    </PermissionedView>
  );
};